export default "__VITE_PUBLIC_ASSET__b8c29b40__"